import { T } from 'gt-react';

/** The marker on a note that comes from the ERP; read-only in Gently. */
export function ErpChip() {
  return (
    <span className="shrink-0 rounded bg-stone-200 px-1 text-[9px] font-semibold tracking-wide text-stone-600 uppercase">
      <T context="chip on an invoice note that comes from the ERP and can't be edited">
        ERP
      </T>
    </span>
  );
}
